import Colors from "./Colors"

const FooterText = {
  fontFamily: "Lato",
  fontSize: "15px",
  lineHeight: "20px",
  color: Colors.footer,
  fontWeight: 400,
}

const CheckItemText = {
  color: Colors.lighterblue,
  fontFamily: "Lato",
  fontSize: "16px",
  lineHeight: "24px",
  fontWeight: 700,
}

const TrustTitle = {
  color: Colors.darkestgrey,
  fontFamily: "Lato",
  fontSize: "16px",
  lineHeight: "24px",
  fontWeight: 700,
}

const TrustBody = {
  color: Colors.darkergrey,
  fontFamily: "Lato",
  fontSize: "16px",
  lineHeight: "23px",
  fontWeight: 400,
}

const HeaderText = {
  color: Colors.lighterblue,
  fontFamily: "Lato",
  fontSize: "18px",
  lineHeight: "24px",
  textAlign: "center",
  fontWeight: "bold",
}

const WidgetTitleText = {
  fontFamily: "Lato",
  fontSize: "24px",
  lineHeight: "32px",
  fontWeight: 700,
  color: Colors.white,
}

const WidgetSubTitleText = {
  color: Colors.white,
  fontFamily: "Lato",
  fontSize: "18px",
  lineHeight: "24px",
  textAlign: "center",
  fontWeight: "bold",
}

export {
  CheckItemText,
  FooterText,
  HeaderText,
  TrustBody,
  TrustTitle,
  WidgetSubTitleText,
  WidgetTitleText,
}
